
const newModel = () => {
    return {
        lichVesinhDothiKhacId: null,
        tuyenDuong: null,
        tanSuat: null,
        thoigianThuchien: null,

        ghiChu: null,
        stt: null,
        enabled: null,
    }
}

const newFEModel = () => {
    return {
        lichVesinhDothiKhacId: null,
        tuyenDuong: null,
        tanSuat: null,
        thoigianThuchien: null,
        ghiChu: null,
        stt: "0",
        enabled: true,
    }
}

const fromJson = (item) => {
    return {
        lichVesinhDothiKhacId: item.lichVesinhDothiKhacId,
        tuyenDuong: item.tuyenDuong,
        tanSuat: item.tanSuat,
        thoigianThuchien: item.thoigianThuchien,
        ghiChu: item.ghiChu,
        stt: item.stt,
        enabled: item.enabled,
    }
}

const parseModeltoFEModel = (item) => {
    return {
        lichVesinhDothiKhacId: item.lichVesinhDothiKhacId,
        tuyenDuong: item.tuyenDuong,
        tanSuat: item.tanSuat,
        thoigianThuchien: item.thoigianThuchien,
        ghiChu: item.ghiChu,
        stt: item.stt,
        enabled: item.enabled,
    }
}

const newPagingSearchModel = () => {
    return {
        lichVesinhDothiKhacId: null,
        tuyenDuong: null,
        tanSuat: null,
        thoigianThuchien: null,
        ghiChu: null,
        enabled: null,
    }

}

const newSearchModel = (item) => {
    return {
        lichVesinhDothiKhacId: item.lichVesinhDothiKhacId,
        tuyenDuong: item.tuyenDuong,
        tanSuat: item.tanSuat,
        thoigianThuchien: item.thoigianThuchien,
        ghiChu: item.ghiChu,
        enabled: item.enabled,
    }
}

const errors = () => {
    return {
        lichVesinhDothiKhacId: null,
        tuyenDuong: null,
        tanSuat: null,
        thoigianThuchien: null,
        ghiChu: null,
        stt: null,
        enabled: null,
    }
}

export const lichVesinhDothiKhacModel = {
    newModel,
    newFEModel,
    parseModeltoFEModel,
    fromJson,
    newPagingSearchModel,
    newSearchModel,
    errors,
}


